export default "__VITE_ASSET__3ZJC5xgv__"